import { render, staticRenderFns } from "./DetalleSupervision.vue?vue&type=template&id=6af53124&"
import script from "./DetalleSupervision.vue?vue&type=script&lang=js&"
export * from "./DetalleSupervision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports